import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import ContestForm from '../../components/Contest/ContestForm';
import BreadCrumb from '../../components/Breadcrumb';
import * as actions from '../../redux/actions/actions-contest';

class addContest extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }
    this.state = {};
  }


  handleSubmit = (FormData) => {
    this.props.saveContest(FormData);
  }


  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Contest" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit Contest</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New Contest</span>}
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                {/* <h3>fnkbfgjbfgb</h3> */}
                <ContestForm
                  onSubmit={this.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addContest.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveContest: PropTypes.func
};

addContest.defaultProps = {
  formLoading: null,
  formError: null,
  saveContest: null
};

const mapStateToProps = ({ contest }) => ({});


const mapDispatchToProps = (dispatch) => ({
  saveContest: (data) => dispatch(actions.saveContest(data)),
  setForm: (id) => dispatch(actions.editContest(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addContest);
